"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/billing-testapi-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Fbilling-testapi-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingTestApiServiceClient = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const billing_testing_service_1 = require("../billing/testing/billing-testing-service");
const protobufPackage = 'com.step.testapi.proto';
/**
 * Billing Test API Service
 */
class BillingTestApiServiceClient {
    rpc;
    name = 'com.step.testapi.proto.BillingTestApiService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/test';
    methods = [{
            name: 'GenerateBill',
            requestType: billing_testing_service_1.GenerateBillRequest,
            responseType: billing_testing_service_1.GenerateBillResponse,
            authenticationOptions: undefined,
        }, {
            name: 'IsUpToDate',
            requestType: billing_testing_service_1.IsUpToDateRequest,
            responseType: billing_testing_service_1.IsUpToDateResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetBillDueAt',
            requestType: billing_testing_service_1.SetBillDueAtRequest,
            responseType: billing_testing_service_1.SetBillDueAtResponse,
            authenticationOptions: undefined,
        }, {
            name: 'ProcessBill',
            requestType: billing_testing_service_1.ProcessBillRequest,
            responseType: billing_testing_service_1.ProcessBillResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetTransactionTime',
            requestType: billing_testing_service_1.SetTransactionTimeRequest,
            responseType: billing_testing_service_1.SetTransactionTimeResponse,
            authenticationOptions: undefined,
        }, {
            name: 'GetUnbilledTransactions',
            requestType: billing_testing_service_1.GetUnbilledTransactionsRequest,
            responseType: billing_testing_service_1.GetUnbilledTransactionsResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetNextAutoPayAt',
            requestType: billing_testing_service_1.SetNextAutoPayAtRequest,
            responseType: billing_testing_service_1.SetNextAutoPayAtResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Generate a bill for an account
     */
    generateBill(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns true if the account can be billed for the given cutoff.
     */
    isUpToDate(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Updates the bill with dueAt, also updating pastDueAt correspondingly.
     * The bill status is not updated.
     */
    setBillDueAt(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Executes any processors currently due to be run for the bill.
     */
    processBill(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Sets the transaction time for an unbilled transaction.
     */
    setTransactionTime(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns unbilled transactions for the given accounts.
     */
    getUnbilledTransactions(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Sets the nextAutoPayAt of an account.
     */
    setNextAutoPayAt(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.BillingTestApiServiceClient = BillingTestApiServiceClient;
//# sourceMappingURL=billing-testapi-service.js.map